import React from 'react';
import AboutMe from '../AboutMe/AboutMe';
import Blog from '../Blog/Blog';
import Contact from '../Contact/Contact';
import Footer from '../Footer/Footer';
import Fun from '../Fun/Fun';
import Header from '../Header/Header';

import Project from '../Project/Project';
import Resume from '../Resume/Resume';
import Service from '../Service/Service';
import Services from '../Service/Services';

import { Fragment } from 'react';
import ScrollButton from './ScrollButton';

const Home = () => {
    return (
        <div style={{ backgroundColor: '#F9FAFD', scrollBehavior: 'smooth' }}>
            <Fragment>
                <Header></Header>
                <AboutMe></AboutMe>
                <Project></Project>
                <Services></Services>
                <Resume></Resume>
                <Blog></Blog>
                <Fun></Fun>
                <Contact></Contact>
                <Footer></Footer>
                <ScrollButton></ScrollButton>
            </Fragment>
        </div>
    );
};

export default Home;